module.exports = __webpack_public_path__ + "static/assets/61edf73198617b2326d37f232b8abd6f.otf";